export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/app-store-badge.43c23090.svg","height":38,"width":121};